import { customScrollMinimal, Drawer } from '@toggle/design-system';
import styled from 'styled-components';

import { EntityHeader } from '~/modules/entity-header/EntityHeader';
import { InsightsDrawerContent } from '~/widgets/insight-widget/components/insight-drawer/components/insights-drawer-content/InsightsDrawerContent';

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Container} {
    width: 90vw;
  }

  ${Drawer.Styled.Body} > * {
    height: 100%;
  }
`;

export const StyledEntityHeader = styled(EntityHeader)`
  margin: 20px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  overflow: hidden;
  height: 100%;
`;

export const Section = styled.div`
  width: 50%;
  height: 100%;

  &:first-child {
    padding: 20px;
    border-right: 2px solid var(--border-soft);
  }

  &:last-child {
    padding: 20px 0 20px 20px;
    height: 100%;
    overflow: scroll;
    ${customScrollMinimal};
  }

  ${InsightsDrawerContent.Styled.Container} {
    padding: 0px;
    overflow-x: hidden;
  }
`;
